/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { InventoryCount } from '../../models/inventory-count';
import { SubmitInventoryCountDto } from '../../models/submit-inventory-count-dto';

export interface InventoryControllerSubmit$Params {
  id: string;
      body: SubmitInventoryCountDto
}

export function inventoryControllerSubmit(http: HttpClient, rootUrl: string, params: InventoryControllerSubmit$Params, context?: HttpContext): Observable<StrictHttpResponse<InventoryCount>> {
  const rb = new RequestBuilder(rootUrl, inventoryControllerSubmit.PATH, 'post');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<InventoryCount>;
    })
  );
}

inventoryControllerSubmit.PATH = '/inventory/counts/{id}/submit';
